module.exports = __webpack_public_path__ + "img/1364.e87a2631.jpg";